(() => {
  if (customElements.get('look-slider')) {
    return;
  }

  class LookSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.thumbs = null;
      this.sliderOptions = {};
      this.thumbsOptions = {};
      this.hotspots = this.querySelectorAll('.js-hotspot');
    }

    connectedCallback() {
      this.initSlider();
      this.attachHotspotListeners();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.sliderOptions = {
        slidesPerView: 1,
      };

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.sliderOptions);

      if (!this.querySelector('[data-thumbs]')) return;

      this.thumbsOptions = {
        slidesPerView: 2.5,
        spaceBetween: 20,
        loop: true,
        centeredSlidesBounds: true,
        centeredSlides: true,
        centerInsufficientSlides: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      };

      this.thumbs = new Swiper(this.querySelector('[data-thumbs]'), this.thumbsOptions);
    }

    attachHotspotListeners() {
      this.hotspots.forEach((hotspot) => {
        const index = hotspot.dataset.index;
        const item = document.querySelector(`#${hotspot.dataset.item}`);
        const gridBlocks = item.closest('.shop-the-look__grid').querySelectorAll('.shop-the-look__produt');

        hotspot.addEventListener('click', () => {
          const currentBullet = this.querySelectorAll('.swiper-pagination-bullet')[index];

          if (currentBullet) {
            currentBullet.click();
          };

          this.removeActiveClass()

          hotspot.classList.add('active');

          gridBlocks.forEach((block) => {
            block.classList.remove('shop-the-look__produt--first');
          });

          item.classList.add('shop-the-look__produt--first');
        });
      });
    }

    removeActiveClass() {
      this.hotspots.forEach((item) => {
        item.classList.remove('active');
      });
    }
  }

  customElements.define('look-slider', LookSlider);
})();
